declare namespace $ {

	export class $shm_hitalama_map_widget_float_ai_request_html_changes extends $shm_hitalama_map_widget_float_ai_request_html {
	}
	
}

//# sourceMappingURL=changes.view.tree.d.ts.map